import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Grid, Typography } from '@mui/material';
import { Progress, Skeleton } from '@mantine/core';
import { formatNumber, returnColor } from '../../utils/functions';
import useFetch from '../../hooks/useFetch';
import useTargets from '../../hooks/useTargets';
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '60vh',
    padding: '20px',
  },
}));

function TeamProgress() {
  const classes = useStyles();
  const { data, isLoading } = useFetch('compensations/team-view/');
  const { selectedYear, isLoading: isTargetLoading } = useTargets();

  if (isLoading || isTargetLoading) {
    return (
      <Box className={classes.root}>
        <Box display="flex" justifyContent="space-between">
          <Skeleton animate={true} height={40} my="5px" width="20%" />
          <Skeleton animate={true} height={40} my="5px" width="40%" />
        </Box>
        <Skeleton animate={true} height={40} my="5px" width="20%" />
        <Skeleton animate={true} height={500} my="5px" />
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h6" sx={{ color: 'var(--primary-color)' }}>
          Teams' Progress: {new Date().getFullYear()}
        </Typography>
        <Typography variant="span">Target Per Team: $ {formatNumber(selectedYear?.amount_per_team || 0)}</Typography>
      </Box>

      {data?.map((team) => {
        const current_amount = team?.total_amount || 0;
        const target_amount = selectedYear?.amount_per_team || Infinity;
        const value = (current_amount / target_amount) * 100;

        return (
          <Grid container spacing={2} my={1} key={team.id}>
            <Grid item xl={2}>
              <Typography>{team.name}</Typography>
            </Grid>
            <Grid item xl={10} sx={{ position: 'relative' }}>
              <span style={{ position: 'absolute', top: '40%', right: '10px', zIndex: 100 }}>
                $ {formatNumber(current_amount)} <b>{formatNumber(value, 0)}%</b>
              </span>
              <Progress value={value} size={30} color={returnColor(value / 100)} />
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
}

export default TeamProgress;
